const defaultState = {
    winnerPrizes: [],
    thankPrizes: [],
    unOpenWinnerPrize: []
};

export const UPDATE_USER_WINNER_PRIZE = 'userWinnerPrize/UPDATE_USER_WINNER_PRIZE';

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPDATE_USER_WINNER_PRIZE:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default reducer;

export function setUserWinnerPrize({ winnerPrizes, thankPrizes, unOpenWinnerPrize }) {
    return {
        type: UPDATE_USER_WINNER_PRIZE,
        payload: {
            winnerPrizes,
            thankPrizes,
            unOpenWinnerPrize
        }
    };
}
